<template>
  <span>
    <b-btn
        @click="newItem"
        v-b-modal="'format-edit-' + id"
        :size="size"
        class="mt-2 mr-2"
        variant="dark"
        title="Nouveau format"
        aria-label="Nouveau format"
    ><b-icon-plus aria-hidden="true"/><slot></slot
    ></b-btn>
    <b-modal
        :id="'format-edit-' + id"
        title="Format"
        no-fade
        size="lg"
        scrollable
        hide-footer
    >
      <form-admin-format
          :format="format"
          @saved="onSaved"
          @new="onNew"
          @update="onUpdate"
      />
    </b-modal>
  </span>
</template>

<script>
import formAdminFormat from './formAdminFormat.vue';

/**
* @vuese
* Bouton d'édition d'un format
* @group COMPONENTS_ADMIN
*/
export default {
  name: 'BtnAdminFormatEdit',
  components: {
    formAdminFormat
  },
  // le format
  props: {
    format: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    // Type de bouton
    variant: {
      type: String,
      default() {
        return 'link';
      }
    },
    // Identifiant du format
    id: {
      type: String,
      default() {
        const rand = Math.random().toString(36).substring(2);
        return '' + rand;
      }
    },
    // Taille du bouton
    size: {
      type: String,
      default: () => 'md'
    }
  },
  methods: {
    /**
     * @vuese
     * Modification du format
     */
    openItem() {
      // Ouverture de la fenêtre modale
      this.$root.$emit('bv::show::modal', 'format-edit-' + this.id);
    },
    /**
     * @vuese
     * Nouveau format
     */
    newItem() {
      this.format = {
        name: ''
      };
    },
    /**
     * @vuese
     * Sauvegarde du format
     * @arg Le format
     */
    onSaved(item) {
      // Sauvegarde du format
      // @arg Le format
      this.$emit('saved', item);
      // Fermeture de la fenêtre modale
      this.$root.$emit('bv::hide::modal', 'format-edit-' + this.id);
    },
    /**
     * @vuese
     * Mise à jour du format
     * @arg Le format
     */
    onUpdate(item) {
      // Mise à jour du format
      // @arg Le format
      this.$emit('update', item);
    },
    /**
     * @vuese
     * Nouveau format
     * @arg Le format
     */
    onNew(item) {
      // Nouveau format
      // @arg Le format
      this.$emit('new', item);
    }
  }
};
</script>
